import React, { useEffect, useState } from 'react'
import { Suspense } from 'react'
import Container from '@mui/material/Container'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { useParams } from 'react-router-dom'
import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid2'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Button from '@mui/material/Button'
import textToSpeech from '../api/TextToSpeech'
import Modal from '@mui/material/Modal'

import { styled } from '@mui/material/styles'
import {
  addPushData,
  updateData,
  getData,
  addRequestsData,
  upsertDataTournaments,
} from '../api/indexedDBHandler'
import UpdateOnline from './Weighing/UpdateOnline'
import OpenWeighing from './Weighing/OpenWeighing'
import Weighing from './Weighing/Weighing'
import Docs from './Weighing/Docs'
import { getLogoUrl } from '../api/Logo'
import LogWeighing from './Logs/LogWeighing'
const TournamentWeighing = () => {
  const { id } = useParams()
  const [loading, setLoading] = useState(false)
  const url_back = '/tournaments/' + id
  const [teams, setTeams] = useState([])
  const [tournament, setTournament] = useState([])
  const [stage, setStage] = useState([])
  const [isWeighingComplete, setIsWeighingComplete] = useState(true)
  const [voices, setVoices] = useState([])
  const [user, setUser] = useState(null)

  const [open, setOpen] = useState(false)

  const [isRussianVoice, setIsRussianVoice] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }))
  Object.size = function (obj) {
    var size = 0,
      key
    for (key in obj) {
      if (obj.hasOwnProperty(key)) size++
    }
    return size
  }
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: 800,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    maxHeight: '90vh',
    overflowY: 'auto',
  }
  useEffect(() => {
    // Проверяем наличие необходимых данных
    if (!Array.isArray(stage)) {
      //  console.error('Stage должен быть массивом')
      return
    }

    if (!Array.isArray(teams)) {
      //  console.error('Teams должен быть массивом')
      return
    }

    if (typeof tournament.weighing !== 'number') {
      //  console.error('Weighing должен быть числом', tournament.weighing)
      return
    }

    // Получаем ID всех команд, которые должны взвешиваться
    const teamIdsToWeigh = teams
      .filter((team) => team.team?.status_location === 1)
      .map((team) => team.team.id)
    console.log('stage', stage)
    // Получаем ID команд, которые уже взвесились в текущем weighing
    const weighedTeamIds = stage
      .filter((record) => record.weighing === tournament.weighing)
      .map((record) => record.teamId)

    // Находим разницу между массивами
    const notWeighedIds = teamIdsToWeigh.filter(
      (id) => !weighedTeamIds.includes(id)
    )

    if (notWeighedIds.length === 0) {
      setIsWeighingComplete(false)
      console.log('Все команды завершили взвешивание')
      // Дополнительные действия при завершении
    } else {
      setIsWeighingComplete(true)

      console.log(`Ожидают взвешивания ${notWeighedIds.length} команд`)
      console.log('ID команд:', notWeighedIds)
    }
  }, [stage, tournament])
  const openWeighing = async (e) => {
    let text = ''
    if (e === 1) {
      text = 'Открыть взвешивание?'
    } else if (e === 2) {
      text = 'Закрыть взвешивание?'
    } else return
    // speak(text)

    textToSpeech.speak(text, {
      lang: 'ru-RU',
      rate: 0.9,
      pitch: 1,
      onStart: () => console.log('Speech started'),
      onEnd: () => console.log('Speech ended'),
      onError: (e) => console.error('Error:', e),
    })

    // eslint-disable-next-line no-restricted-globals
    const result = confirm(text)
    if (result) {
      const w = tournament.weighing + 1
      const update_data = {
        status_cup: e === 1 ? 'Взвешивание' : 'Активен',
        weighing: w,
        requestKey: `${id}_statusCupW_${new Date().getTime()}`,
      }
      // const requestKey = `${id}_dellUser_${new Date().getTime()}`
      // requestKey:  `${id}_dellUser_${new Date().getTime()}`,
      await updateData('tournaments', id, {
        ...update_data,
      })
      setTournament((prev) => ({
        ...prev,
        ...update_data,
      }))

      try {
        await addRequestsData('requests', {
          url: 'tournaments/statusCupW.php',
          ...update_data,
          id: id,
        })
      } catch (error) {}
    }

    console.log('openWeighing', e)
  }
  const updateDataOfflain = async () => {
    const getTournamentTeams = async () => {
      const resultsU = await getData('teams', 'id', id)
      if (resultsU.length > 0) {
        const { key, value } = resultsU[0]
        const teamsArray = Object.values(value)
        console.log('teamsArrayteamsArrayteamsArray', teamsArray)
        const filteredTeams = teamsArray.filter((teamEntry) => {
          const isValidTeam =
            teamEntry !== null &&
            typeof teamEntry === 'object' &&
            teamEntry.team?.status === 'Заявка одобрена' &&
            teamEntry.team?.status_location === 1

          return isValidTeam
        })
        //  exportToTxt(filteredTeams)
        setTeams(filteredTeams)
      }

      const resultsT = await getData('tournaments', 'id', id)
      if (resultsT.length > 0) {
        const { key, value } = resultsT[0]
        console.log(value)
        setTournament(value)
      }

      const resultsS = await getData('stage', 'id', id)
      if (resultsS.length > 0) {
        const { key, value } = resultsS[0]
        console.log(value)

        setStage(value.items || [])
      }
    }
    getTournamentTeams()
  }
  useEffect(() => {
    setLoading(true)
    updateDataOfflain()
    setLoading(false)
    const gerUserU = async () => {
      try {
        const results = await getData('user', 'created', true)
        const value = results[0]?.value || null
        setUser(value)
      } catch (error) {}
    }
    gerUserU()
  }, [id])

  function exportToTxt(data, filename = 'data.txt') {
    console.log('data.txt', data)
    // Проверяем, что data существует и является массивом
    if (!data || !Array.isArray(data)) {
      console.error('Ошибка: data должен быть массивом')
      return
    }

    // Проверяем, что массив не пустой
    if (data.length === 0) {
      console.warn('Предупреждение: массив data пуст')
      return
    }

    try {
      // Преобразуем массив объектов в текстовый формат
      let textContent = data
        .map((obj) => {
          // Проверяем, что элемент является объектом
          if (typeof obj !== 'object' || obj === null) {
            return String(obj) // Просто преобразуем в строку, если не объект
          }
          return Object.entries(obj)
            .map(([key, value]) => `${key}: ${JSON.stringify(value)}`)
            .join('\n')
        })
        .join('\n\n')

      // Создаем Blob
      const blob = new Blob([textContent], { type: 'text/plain' })

      // Создаем ссылку для скачивания
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename

      // Инициируем скачивание
      document.body.appendChild(a)
      a.click()

      // Очищаем
      setTimeout(() => {
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      }, 100)
    } catch (error) {
      console.error('Ошибка при создании файла:', error)
    }
  }
  // useEffect(() => {
  //   const updateVoices = () => {
  //     const availableVoices = window.speechSynthesis.getVoices()
  //     setVoices(availableVoices)
  //   }

  //   // Для Chrome нужно ждать события voiceschanged
  //   window.speechSynthesis.onvoiceschanged = updateVoices
  //   updateVoices() // Первоначальная загрузка

  //   return () => {
  //     window.speechSynthesis.onvoiceschanged = null
  //   }
  // }, [])

  const responseTeams = (response) => {
    console.log('responseTeams', response)
    const teamsArray = Object.values(response)
    const filteredTeams = teamsArray.filter((teamEntry) => {
      const isValidTeam =
        teamEntry !== null &&
        typeof teamEntry === 'object' &&
        teamEntry.team?.status === 'Заявка одобрена' &&
        teamEntry.team?.status_location === 1

      return isValidTeam
    })
    setTeams(filteredTeams)
  }

  const responseTournaments = (response) => {
    console.log('responseTournaments', response)
    setTournament(response)
  }

  const responseStage = (response) => {
    console.log('responseStage', response)

    setStage(response)
  }

  const responseWeighing = async (response) => {
    console.log('responseWeighing', user.phone)
    response.admin = Number(user.phone)
    const saver = {
      ...response,
      weighing: tournament.weighing,
      id: id,
      confirmed: null,
      requestKey: `${id}_addStage_${new Date().getTime()}`,
    }
    // const requestKey = `${id}_dellUser_${new Date().getTime()}`
    // requestKey:  `${id}_dellUser_${new Date().getTime()}`,
    console.log('stage', stage)

    console.log('saver', saver)

    setStage((prev) => [...prev, saver])

    //  addData(tableName, data)
    addPushData('stage', id, saver)

    try {
      await addRequestsData('requests', {
        url: 'tournaments/addStage.php',
        ...saver,
        id: id,
      })
    } catch (error) {}

    // var obj = {}
    // obj[tournament.weighing][saver.teamId] = { ...saver }
    // await updateData('stage', id, {
    //   obj,
    // })

    console.log(saver)
  }

  // const speak = (text) => {
  //   if (!voices.length) {
  //     console.warn('Голоса не загружены')
  //     return
  //   }

  //   const russianVoice = voices.find((v) => v.lang.includes('ru-RU')) // 3. Теперь voices определено

  //   if (russianVoice) {
  //     console.log(text)
  //     const utterance = new SpeechSynthesisUtterance(text)
  //     utterance.voice = russianVoice
  //     window.speechSynthesis.speak(utterance)
  //   } else {
  //     console.error('Русский голос не найден')
  //   }
  // }

  // ...остальной JSX
  const ItemWithUserCheck = ({ stage, user }) => {
    // Если user еще не загружен, показываем заглушку
    if (!user) {
      return <div>Загрузка данных пользователя...</div>
      // Или return null; если не нужно показывать ничего
    }

    return (
      <Item>
        <LogWeighing stage_={stage} admin={user.phone} isSuperAdmin />
      </Item>
    )
  }

  const regexDraw = /(Главный судья|Судья|Главный секретарь|Судья - секретарь)/i
  //speak('Взвешивание команды A S V Team')
  if (tournament && teams)
    return (
      <Container sx={{ mb: 15 }}>
        <div role="presentation" style={{ textAlign: 'left', width: '100%' }}>
          <Breadcrumbs maxItems={2} aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/tournaments-list">
              Турниры
            </Link>
            <Link underline="hover" color="inherit" href={url_back}>
              Редактирование
            </Link>
            <Typography sx={{ color: 'text.primary' }}>Взвешивание</Typography>
          </Breadcrumbs>
        </div>
        <Box sx={{ flexGrow: 1, mt: 2 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 12 }}>
              <Item>
                <Stack spacing={1} direction="row">
                  <div>
                    {tournament.logocup && (
                      <img
                        alt="Logo Team"
                        variant="square"
                        src={getLogoUrl(tournament?.logocup)}
                        style={{
                          objectFit: 'contain !important',
                          height: '60px',
                        }}
                      />
                    )}
                  </div>
                  <div>
                    <Stack spacing={0}>
                      <Typography
                        variant="h6"
                        gutterBottom
                        color="black"
                        style={{ lineHeight: 'normal', marginBottom: 0 }}
                      >
                        {tournament.tournament_name}
                      </Typography>
                      <Typography
                        variant="body2"
                        gutterBottom
                        color="black"
                        style={{ lineHeight: 'normal', marginBottom: 0 }}
                      >
                        Водоём: {tournament.water_body}
                      </Typography>
                      <Typography
                        variant="body2"
                        gutterBottom
                        color="black"
                        style={{ lineHeight: 'normal' }}
                      >
                        Дата: {tournament.start_date} - {tournament.end_date}
                      </Typography>
                    </Stack>
                  </div>
                </Stack>
                <Typography
                  variant="body2"
                  gutterBottom
                  color="black"
                  style={{ lineHeight: 'normal' }}
                >
                  Количество команд: {Object.size(teams)}
                </Typography>
                <Typography
                  variant="body2"
                  gutterBottom
                  style={{ lineHeight: 'normal', marginBottom: 0 }}
                >
                  Статус: {tournament.status_cup}
                </Typography>
                <Typography
                  variant="body2"
                  gutterBottom
                  style={{ lineHeight: 'normal', marginBottom: 0 }}
                >
                  Формат: {tournament.competition_format}
                </Typography>
              </Item>
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Item>
                <UpdateOnline
                  id={id}
                  responseTournaments={responseTournaments}
                  responseTeams={responseTeams}
                  responseStage={responseStage}
                />
              </Item>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Item>
                <Weighing
                  response={responseWeighing}
                  condition_={tournament.status_cup}
                  teams_={teams}
                  stage_={stage}
                  weighing_={tournament.weighing}
                  type={tournament.competition_type}
                />
              </Item>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Item>
                <OpenWeighing
                  response={openWeighing}
                  condition_={tournament.status_cup}
                  isWeighingComplete={isWeighingComplete}
                />
              </Item>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <Item>
                <Typography variant="h6" gutterBottom>
                  <b> Дополнительное взвешивание</b>
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Внеплановое взвешивание одной команды.
                </Typography>

                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  size="small"
                  onClick={handleOpen}
                >
                  Выбрать сектор
                </Button>
              </Item>
            </Grid>
            {/* <Grid size={{ xs: 12, md: 12 }}>
              <Item>
                <Docs stage_={stage} />
              </Item>
            </Grid> */}
            <Grid size={{ xs: 12, md: 6 }}>
              <Suspense fallback={<div>Загрузка...</div>}>
                <Item>
                  {user && (
                    <LogWeighing
                      stage_={stage}
                      admin={user.phone}
                      isSuperAdmin={regexDraw.test(tournament.roles)}
                    />
                  )}
                </Item>
              </Suspense>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Item>
                Сдать взвешивание / обновить данные - через Qr-code (в
                разработке)
              </Item>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Item>
                Редактировать взвешивание - главный судья (в разработке)
              </Item>
            </Grid>
          </Grid>
        </Box>

        <div>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Item>
                <Weighing
                  response={responseWeighing}
                  condition_="Дополнителное"
                  teams_={teams}
                  stage_={stage}
                  weighing_={Number(tournament.weighing) + 1}
                  type={tournament.competition_type}
                />
              </Item>
            </Box>
          </Modal>
        </div>
      </Container>
    )
}

export default TournamentWeighing
